import { ValidatorService } from './../../../core/service/app/validator.service';
import { Component, OnInit } from '@angular/core';
import { FormBaseComponent } from '../../core/component/form-base/form-base.component';
import { FormControl, Validator, Validators } from '@angular/forms';
import { IMyDpOptions } from 'mydatepicker';

@Component({
  selector: 'app-contact-form',
  templateUrl: './contact-form.component.html',
  styleUrls: ['./contact-form.component.scss']
})
export class ContactFormComponent extends FormBaseComponent<any> implements OnInit {

  private dateOptions: IMyDpOptions = {
    dateFormat: 'dd/mm/yyyy',
  };

  onDateChanged(data) {
    /*setTimeout(() => {
      this.form.patchValue({ 'birthDay': data.formatted });
    }, 500);*/
  }

  constructor(private validatorService: ValidatorService) {
    super();
  }

  ngOnInit() {
    this.init(true);
  }

  template(){
    this.form.addControl('name', new FormControl(''));
    this.form.addControl('secondName', new FormControl(''));
    this.form.addControl('lastNamePaternal', new FormControl(''));
    this.form.addControl('lastNameMaternal', new FormControl(''));
    //this.form.addControl('birthDay', new FormControl(null));
    //this.form.addControl('birthPlace', new FormControl(null));
    this.form.addControl('phone', new FormControl('', [this.validatorService.telefono]));
    this.form.addControl('cellPhone', new FormControl('', [this.validatorService.celular]));
    this.form.addControl('email', new FormControl(null, [Validators.email]));
  }

}



// WEBPACK FOOTER //
// ./src/app/form/form/contact-form/contact-form.component.ts